import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';

export interface IContentContainer extends IBaseElementProps {
	children?: any;
}

/**
 * Content Container
 * @block
 * @requiresHooks
 * @icon align-center
 */

const ContentContainer: React.FC<IContentContainer> = ({
	className,
	children,
}) => (
	<div className={className || cn('content-container', className)}>
		{children}
	</div>
);

export default ContentContainer;
